import React from 'react';
import EntityEditOverlay from './EntityEditOverlay';
import EntityWizardOverlay from './EntityWizardOverlay';

const WorkspaceFormOverlay = ({
  overlayMode, overlayEntity, overlayRowData, onEditSave, onOverlayClose,
  formOpen, formEntity, formDetailEntity, formKey, formRowData, formScriptName, formTitle, formSaveLabel, formForceCreate,
  onFormSave, onFormClose,
  colors,
}) => {
  return (
    <>
      {overlayMode && overlayEntity && (
        <EntityEditOverlay
          entityName={overlayEntity}
          rowData={overlayRowData}
          readOnly={overlayMode === 'view'}
          colors={colors}
          onSave={onEditSave}
          onClose={onOverlayClose}
        />
      )}

      {formOpen && formEntity && (
        <EntityWizardOverlay
          entityName={formEntity}
          detailEntityName={formDetailEntity}
          wizardKey={formKey}
          rowData={formRowData}
          scriptName={formScriptName}
          title={formTitle}
          saveLabel={formSaveLabel}
          forceCreate={formForceCreate}
          colors={colors}
          onSave={onFormSave}
          onClose={onFormClose}
        />
      )}
    </>
  );
};

export default WorkspaceFormOverlay;
